import { Injectable } from '@angular/core';
import { Preferences } from '@capacitor/preferences';

import { PrinterConfig } from '../../models/printer-config.model';

const PREFERENCES_KEY = 'printerConfig';

@Injectable({ providedIn: 'root' })
export class PrinterConfigService {

  async getConfig(): Promise<PrinterConfig | null> {
    const { value } = await Preferences.get({ key: PREFERENCES_KEY });
    if (!value) {
      return null;
    }

    try {
      return JSON.parse(value) as PrinterConfig;
    } catch {
      return null;
    }
  }

  async saveConfig(config: PrinterConfig): Promise<void> {
    await Preferences.set({ key: PREFERENCES_KEY, value: JSON.stringify(config) });
  }

  async hasConfig(): Promise<boolean> {
    const config = await this.getConfig();
    return !!config?.ip;
  }
}
